<template>
  <div class="tile is-ancestor">
    <div class="tile is-vertical is-12">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <nav
            class="breadcrumb is-medium"
            aria-label="breadcrumbs"
          >
            <ul class="p-l-md">
              <li v-if="$route.matched[0].meta.schoolType !== 'eschool'">
                <router-link :to="{ name: 'highschool-categories'}">
                  {{ $t('shop.offers.list') }}
                </router-link>
              </li>
              <li v-else>
                <router-link :to="{ name: 'eshop-categories'}">
                  {{ $t('shop.offers.list') }}
                </router-link>
              </li>
              <li class="is-active">
                <a class="has-text-weight-light title is-5">{{ $t('shop.cart.epreferences') }}</a>
              </li>
            </ul>
            <hr>
          </nav>

          <section
            id="candidate-view"
            class="card m-t-md"
          >
            <div
              class="school-border "
              :class="schoolSlug"
            />
            <header class="card-header">
              <p class="card-header-title title  has-text-weight-light">
                {{ $t('shop.cart.epreferences') }}
              </p>
            </header>

            <div class="card-content">
              <div class="content">
                <div v-if="hasCandidates && hasCandidateOrder">
                  <div v-for="candidate in candidates">
                    <component
                      :is="schoolingItemsView"
                      :candidate="candidate"
                      :checkout="true"
                      :status="'pending'"
                    />
                  </div>
                </div>
                <div>
                  <component
                    :is="offerItemsView"
                    :checkout="true"
                    :status="'pending'"
                    @offer="displayOffer"
                  >
                    >
                  </component>
                </div>
                <div class="m-t-lg">
                  <component
                    :is="guestItemsView"
                    :checkout="true"
                    :status="'pending'"
                  />
                </div>
              </div>
            </div>

            <footer class="p-t-md p-b-md">
              <hr>
              <div
                v-if="cartHasChoiceItems"
                class="has-text-centered"
              >
                <div class="title is-5 ">
                  <i class="has-text-weight-light">{{ $t('shop.cart.price') }} :</i>
                  <strong>{{ cartTotalCheckout }} {{ schoolCurrency() }}</strong>
                </div>

                <div
                  v-if="isSchoolingOrder && cartDiscount()"
                  class="title is-6 is-italic"
                >
                  <i v-if="discountValue > 0">{{ $tc('offers.cart.discount', 1, {n: discountValue, d: discountDate}) }}</i>
                </div>
              </div>

              <span
                v-if="!hasCandidateOrder"
                class="card-footer-item is-size-5 has-text-centered has-background-warning p-sm m-b-lg"
              >
                {{ $t('shop.cart.no_offer_candidate') }}
              </span>
              <span
                v-if="cartGuestChoices.length"
                class="card-footer-item is-size-5 has-text-centered has-background-warning p-sm m-b-lg"
              >
                {{ $t('shop.cart.no_offer_cart') }}
              </span>
            </footer>
          </section>


          <section
            id="payment-view"
            class="card m-t-md"
          >
            <div
              class="school-border "
              :class="schoolSlug"
            />
            <header class="card-header">
              <p class="card-header-title title  has-text-weight-light">
                {{ $t('shop.cart.checkout') }}
              </p>
            </header>
            <div class="card-content">
              <div class="content">
                <transition name="slide-fade">
                  <div
                    v-if="cbError"
                    class="has-text-danger has-text-centered"
                  >
                    {{ cbError }}
                  </div>
                </transition>
                <transition
                  name="component-fade"
                  mode="out-in"
                >
                  <component
                    :is="paymentView"
                    :school="school"
                    :candidate="candidates ? candidates[0]:null"
                    :candidates="candidates"
                    :class="[!hasCandidateOrder || cartGuestChoices.length ? '  app-disabled':'']"
                    :guarantor="guarantor"
                    :cart-discount="cartDiscount()"
                    :discount-date="discountDate"
                    :discount-value="discountValue"
                    @send="savePayment"
                    @edit="editPayment"
                  />
                </transition>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import OrderPayments from './payment/OrderPayments.vue'
import GuestItemsView from './cart/GuestItems'
import OfferItemsView from './cart/OfferItems'
import SchoolingItemsView from './cart/SchoolingItems'
import NewChildForm from './NewChildForm'
import settings from 'services/organization'

export default {
  props: {
    candidates: {type: Array}
  },
  data() {
    return {
      schoolingItemsView: SchoolingItemsView,
      guestItemsView: GuestItemsView,
      offerItemsView: OfferItemsView,
      paymentView: OrderPayments,
      childFormView: NewChildForm,
      checkboxContract: false,
      guarantor: null,
      showChildForm: false,
      cbError: null,
      discounts: null
    }
  },
  computed: {
    ...mapGetters(
        'orders', [
          'isSchoolingOrder',
          'cartHasChoiceItems',
          'cartTotalCheckout',
          'checkoutStatus',
          'hasCandidateOrder',
          'cartGuestChoices',
          'candidateSchoolingDetails',
          'candidateSchoolingInOrder',
          'selectedOrder'
        ]
    ),
    ...mapGetters(
        'organization', [
          'getSchoolBySlug',
          'currentScholarYear',
          'nextScholarYear'
        ]
    ),
    ...mapGetters('candidate', [
      'hasCandidates'
    ]),
    school() {
      return this.getSchoolBySlug(this.$route.params.school)
    },
    schoolSlug() {
      const school = this.getSchoolBySlug(this.$route.params.school)
      if (school) {
        return school.slug
      }
    },
    discountDate() {
      if (this.discounts) {
        let dates = this.discounts['date_discount'][0].date.split('/')
        const currentYear = moment().year()
        return moment().year(currentYear).month(dates[1] - 1).date(dates[0]).format('LL')
      }
    },
    discountValue() {
      if (this.discounts) {
        return this.discounts['date_discount'][0].value
      }
    },

  },
  methods: {
    ...mapActions(
        'orders', [
          'removeChoiceFromCart',
          'addChoiceToCart',
          'selectOrder'
        ]
    ),
    displayOffer(offer) {
      this.$emit('offer', offer)
    },
    schoolCurrency() {
      const school = this.getSchoolBySlug(this.$route.params.school)
      if (school) {
        return school.fees_currency
      }

    },
    cartDiscount() {

      if (this.discounts) {
        let dates = this.discounts['date_discount'][0].date.split('/')
        let schooling = this.candidateSchoolingInOrder(this.candidates, 'pending')
        let now = moment()
        const currentYear = moment().year()
        const endDiscount = moment().year(currentYear).month(dates[1] - 1).date(dates[0])
        return (schooling && schooling.applications.choices[0].scholar_year === this.nextScholarYear) && moment(now).isBefore(endDiscount)
      }
    },
    savePayment() {
      if (this.$route.matched[0].meta.schoolType === 'highschool') {
        this.$router.replace({name: 'highschool-order', params: {orderId: this.selectedOrder.id}})
      }
      if (this.$route.matched[0].meta.schoolType === 'eschool') {
        this.$router.replace({name: 'eshop-order', params: {orderId: this.selectedOrder.id}})
      }

    },
    editPayment() {
      this.paymentView = OrderPayments

    },
    displayChildForm() {
      this.showChildForm = true
      this.$scrollTo('#child-form-view', {offset: 10}, 200)
    },
    saveCandidate() {
      this.$scrollTo('.app-container', {offset: 500}, 200)
      this.showChildForm = false
    },
  },
  created() {
    this.selectOrder(null)
    settings.settings().then((result) => {
      this.discounts = JSON.parse(result.data[5].value)
    }).catch((err) => {
      this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
    })
    if (this.$route.hash === '#error') {
      setTimeout(() => {
        this.$scrollTo('#payment-view', 500, {offset: -150})
        this.cbError = 'Votre paiement par carte bleue n\'est pas validé, vous pouvez choisir un autre moyen de paiement'

      }, 50)
    }
  }
}
</script>

<style scoped>

</style>
